/**
 * @generated SignedSource<<ba64e63dc77d934aba310f27ceb45ae2>>
 * @relayHash 5098fd883ef9f160372123a67bc2d969
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5098fd883ef9f160372123a67bc2d969

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteProgressNotesInput = {
  ids: ReadonlyArray<string>;
};
export type chDeleteProgressNotesMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_deleteProgressNotesInput;
};
export type chDeleteProgressNotesMutation$data = {
  readonly deleteProgressNotes: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly progressNote: ReadonlyArray<{
      readonly id: string;
    }> | null;
  };
};
export type chDeleteProgressNotesMutation = {
  response: chDeleteProgressNotesMutation$data;
  variables: chDeleteProgressNotesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chDeleteProgressNotesMutation",
    "selections": [
      {
        "alias": "deleteProgressNotes",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteProgressNotesPayload",
        "kind": "LinkedField",
        "name": "ch_deleteProgressNotes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "ch_ProgressNote",
            "kind": "LinkedField",
            "name": "ch_ProgressNote",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chDeleteProgressNotesMutation",
    "selections": [
      {
        "alias": "deleteProgressNotes",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteProgressNotesPayload",
        "kind": "LinkedField",
        "name": "ch_deleteProgressNotes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "ch_ProgressNote",
            "kind": "LinkedField",
            "name": "ch_ProgressNote",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5098fd883ef9f160372123a67bc2d969",
    "metadata": {},
    "name": "chDeleteProgressNotesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8830e5db2f10b5f05e22a00904792eb5";

export default node;
